import { getEcommerceSettings as publicGetEcommerceSettings } from './ecom-v1-ecommerce-settings-ecommerce-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getEcommerceSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetEcommerceSettings> &
    typeof publicGetEcommerceSettings
> = /*#__PURE__*/ createRESTModule(publicGetEcommerceSettings);

export {
  TriggerFlow,
  LogoSize,
  Alignment,
  DisplayType,
  ExpressButtonsCornerRadius,
  InputFieldBackgroundStyle,
  CheckoutBillingFields,
  DestinationScope,
  RequestedFields,
  FeaturePeriod,
  ContractSwitchClassification,
  WebhookIdentityType,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';
export {
  EcommerceSettings,
  ServicePluginConfiguration,
  ActiveProvider,
  TaxConfiguration,
  DiscountRulesConfiguration,
  CheckoutSettings,
  CheckoutPolicies,
  TermsAndConditionsPolicy,
  PrivacyPolicy,
  ReturnPolicy,
  DigitalItemPolicy,
  ContactUsPolicy,
  CustomCheckoutPolicy,
  CheckoutFields,
  CheckboxField,
  CheckoutBrand,
  CheckoutHeader,
  Logo,
  FocalPoint,
  ContinueShopping,
  BackgroundFill,
  BackgroundFillOptionsOneOf,
  CheckoutMain,
  CheckoutFooter,
  CheckoutGlobal,
  DeliveryConfiguration,
  Destination,
  CountryDeliveryProperties,
  DeliveryDestinationProperties,
  SubdivisionDeliveryProperties,
  BusinessProperties,
  Locale,
  Address,
  StreetAddress,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  GetEcommerceSettingsRequest,
  GetEcommerceSettingsResponse,
  Error,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  FeatureEvent,
  FeatureEventEventOneOf,
  FeatureEnabled,
  FeatureEnabledReasonOneOf,
  Feature,
  FeatureQuantityInfoOneOf,
  FeatureContext,
  BooleanFeature,
  QuotaFeature,
  QuotaInfo,
  QuotaInfoEntry,
  TransferredFromAnotherAccountReason,
  ReassignedFromSiteReason,
  AssignedFromFloatingReason,
  NewFeatureReason,
  ContractSwitchedReason,
  ManualFeatureCreationReason,
  MigratedFromLegacyReason,
  ManualSyncReason,
  FeatureDisabled,
  FeatureDisabledReasonOneOf,
  UnAssingedToFloatingReason,
  ReplacedByAnotherSubscriptionReason,
  ReassignedToAnotherSiteReason,
  FeatureUpdated,
  FeatureUpdatedPreviousQuantityInfoOneOf,
  FeatureUpdatedReasonOneOf,
  FeatureCancelled,
  FeatureCancelledReasonOneOf,
  TransferredToAnotherAccountReason,
  CancelRequestedReason,
  QuotaExhaustedReason,
  FeatureQuotaUsageChanged,
  EcomSitePropertiesChangedEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';
export {
  TriggerFlowWithLiterals,
  LogoSizeWithLiterals,
  AlignmentWithLiterals,
  DisplayTypeWithLiterals,
  ExpressButtonsCornerRadiusWithLiterals,
  InputFieldBackgroundStyleWithLiterals,
  CheckoutBillingFieldsWithLiterals,
  DestinationScopeWithLiterals,
  RequestedFieldsWithLiterals,
  FeaturePeriodWithLiterals,
  ContractSwitchClassificationWithLiterals,
  WebhookIdentityTypeWithLiterals,
  GetEcommerceSettingsApplicationErrors,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';
